import { useAccountCompanyId } from 'application/hooks';
import { useUserBillingInfo } from '@entities/billing';

import { UseDiscountViewModel } from './types';

const useDiscountViewModel = (): UseDiscountViewModel => {
  const companyId = useAccountCompanyId();

  const { watchBillingInfo } = useUserBillingInfo();

  const { discount, nextBillingPriceAmount } = watchBillingInfo(companyId);

  return {
    discount,
    nextBillingPriceAmount: nextBillingPriceAmount || 0,
  };
};

export default useDiscountViewModel;
